<div class="full-page w-100 d-flex px-0">
  <!--Left Side-->
  <div class="container">
    <img src="assets/images/rewards-logo.png" alt="" class="logo" />
    <!--Right Side-->
    <div class="right-side-maintenance">
      <span class="icon logo-maintenance material-icons">engineering</span>
      <h4 class="title-maintenance panel-text font-size-20 fw-bold">
        {{ 'maintenance.page.title' | translate }}
      </h4>
      <div class="font-size-14 text-start description-two text-center">
        {{ 'maintenance.page.description' | translate }}
      </div>
    </div>
  </div>
</div>
